


























import { Vue, Component, Inject, Prop } from "vue-property-decorator";

// Enums/Data
import {
  ICProdProvider,
  ICProdProviderMethods
} from "@/models/providers/contractProduct";
import { ClientRoutes } from "@/data/enums/router";

@Component
export default class CProdAutoExpireMsg extends Vue {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => ICProdProvider;

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: ICProdProviderMethods;

  // Props

  @Prop({ default: false })
  public readonly isAlwaysVisible!: boolean;

  // Data

  public isProcessing = false;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  public get isVisible() {
    if (!this.cProdData.hasAutoExpireEnabled) return false;
    return (
      this.isAlwaysVisible ||
      ![
        ClientRoutes.CONTRACT_PRODUCT_SETTINGS,
        "adminClientCProdSettings"
      ].includes(this.$route.name as string)
    );
  }

  public get calculatedCancelDate() {
    return this.$_.get(
      this.cProdData.contractProduct,
      "calculated_cancel_date"
    );
  }

  // Methods

  public async turnOffAutoExpire() {
    try {
      this.isProcessing = true;
      await this.$cProdMethods.toggleAutoExpire(false);
    } finally {
      this.isProcessing = false;
    }
  }
}
